module.exports = __webpack_public_path__ + "img/left-grey.14b57469.png";